import type MP4Box from 'mp4box';
import type { AddError } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';

const validateVideoType = (info: MP4Box.Mp4BoxInfo, allowMoreVideoCodecs: boolean, addError: AddError): void => {
  const codec = info.videoTracks[0].codec?.toLowerCase();
  if (!codec) {
    addError(VALIDATIONS.INVALID_FORMAT);
    return;
  }
  const types = allowMoreVideoCodecs ? ['avc1', 'av01', 'hev1', 'hvc1'] : ['avc1'];
  if (!types.some((type) => codec.includes(type))) {
    addError(VALIDATIONS.INVALID_FORMAT);
  }
};

export default validateVideoType;
